import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'salaryDivider' })
export class SalaryDividerPipe implements PipeTransform {

  constructor() {}

  transform(value: any, ...args: any[]): any {
    if (value) {
      return String(value).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
    }
    return '';
  }

}
